// style
import './style/fourthStep.css'
// progress
import Progress from "../../../components/progress/progress";
// form
import { useForm, FieldErrors } from 'react-hook-form';
// make query
import { sendAddress } from "../../../services/auth/address/sendAddress";
import { useMutation } from "@tanstack/react-query";
// toast
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toastOptions } from "../../../features/toast/toast";
// routes
import { routes } from "../../../features/routes/route";
// navigate
import { NavLink } from "react-router-dom";
// hook
import { useEffect, useState } from "react";
// @ts-ignore
import Cookies from "js-cookie";
import Step from '../../../features/step/step';
// errorText text


const FoursStep = () => {
    const [address, setAddress] = useState<any>()
    const { register, reset, handleSubmit }: any = useForm<any>();
    const AddressMutation = useMutation({
        mutationFn: sendAddress,
        onSuccess: data => {
            setAddress(data);
            let defaultValues = {
                fatherName: Cookies.get('fatherName'),
                identificationNo: Cookies.get('identificationNo'),
                adress: data?.province ? `${data?.province} - ${data?.city} - ${data?.locality} - ${data?.stopStreet} - ${data?.no} - ${data?.floor}` : '',
                city: data.city,
                province: data.province,
            }
            reset(defaultValues)
        },
        onError: (data: any) => {
            toast.error(data?.response?.data?.message, toastOptions);
        }
    });
    const getAddress = () => {
        let value = (document.getElementById('postalCode') as HTMLInputElement)!.value;
        if (value != '') {
            let data: any = {
                tel: (document.getElementById('digit0') as HTMLInputElement)!.value,
                telCode: (document.getElementById('digit1') as HTMLInputElement)!.value,
                postalCode: value,
                phoneNumber: Cookies.get('mobileNumber'),
            }
            AddressMutation.mutate(data)
        } else {
            toast.error("اول کدپستی را وارد نمایید.", toastOptions);
        }
    }

    useEffect(() => {
        let defaultValues = {
            fatherName: Cookies.get('fatherName'),
            identificationNo: Cookies.get('identificationNo'),
        }
        reset(defaultValues)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const onFinish = () => {
        window.open('/signUp/payment', '_self')
    }
    const onError = (errors: FieldErrors<any>) => {
        const uniqueErrorMessages = new Set<string>();
        Object.values(errors).forEach((error) => {
            if (error?.message) {
                uniqueErrorMessages.add(error.message as string);
            }
        });
        uniqueErrorMessages.forEach((message) => {
            toast.error(message, toastOptions);
        });
    };
    return (
        <>
            <Progress number={3} />
            <section className={'container pb-3'}>
                <div className={'row justify-content-center'}>
                    <div className={'col-lg-10 col-12'}>
                        <form onSubmit={handleSubmit(onFinish, onError)}>
                            <h1 className={'h2 fw-bold text-white text-center'}>
                                اطلاعات تکمیلی
                            </h1>
                            <div className={'row mt-4'}>
                                <div className={'col-md-6 oder-md-0 order-1'}>
                                    <div className={'row align-items-center'}>
                                        <div className={'col-md-6 mb-2'}>
                                            <fieldset
                                                className={'mt-3'}>
                                                <label className={'form-label text-white mb-3'}>
                                                    نام پدر
                                                </label>
                                                <input
                                                    disabled={true}
                                                    type={'text'}
                                                    className={'form-control blue-bg'}
                                                    {...register('fatherName', { required: 'اسم پدر الزامی ست' })}
                                                />
                                            </fieldset>
                                        </div>
                                        <div className={'col-md-6 mb-2'}>
                                            <fieldset
                                                className={'mt-3'}>
                                                <label className={'form-label text-white mb-3'}>
                                                    شماره شناسنامه
                                                </label>
                                                <input
                                                    disabled={true}
                                                    type={'tel'}
                                                    id={'code'}
                                                    className={'form-control blue-bg'}
                                                    {...register('identificationNo', { required: 'شماره شناسنامه الزامی ست' })}
                                                />
                                            </fieldset>
                                        </div>
                                    </div>
                                    <div className={'row align-items-center mt-3'}>
                                        <label className={'form-label text-white mb-3'}>
                                            شماره تلفن ثابت
                                        </label>
                                        {Array.from({ length: 2 }, (_, index) => (
                                            <fieldset key={index} className={`${index === 0 ? 'col-6 mb-2' : 'col-lg-2 col-md-3 col-6 mb-2'}`}>
                                                <input
                                                    type="tel"
                                                    maxLength={index === 0 ? 8 : 3}
                                                    defaultValue={index === 0 ? null : 0}
                                                    id={`digit${index}`}
                                                    className={`form-control step-input  `}
                                                    onKeyDown={(e) => Step(e, index, `digit`)}
                                                    {...register(`phone.${index + 1}`, {
                                                        required: "پیش شماره و یا شماره تلفن را فراموش کرده اید",
                                                    })}
                                                />
                                            </fieldset>
                                        ))}
                                    </div>
                                    <div className={'row align-items-end'}>
                                        <div className={'col-6 mb-2'}>
                                            <fieldset
                                                className={'mt-3'}>
                                                <label className={'form-label text-white mb-3'}>
                                                    کد پستی
                                                </label>
                                                <input
                                                    type={'tel'}
                                                    id={'postalCode'}
                                                    className={'form-control'}
                                                    maxLength={10}
                                                    {...register('postalCode', {
                                                        required: 'فیلد کدپستی الزامی است',
                                                        pattern: {
                                                            value: /^\d{10}$/,
                                                            message: 'کد پستی باید دقیقا 10 رقم باشد'
                                                        }
                                                    })}
                                                />
                                            </fieldset>
                                        </div>
                                        <div className={'col-6 mb-2'}>
                                            <button disabled={AddressMutation.isPending} onClick={() => getAddress()} type={'button'}
                                                className={'btn w-100 form-btn mt-5'}>
                                                {AddressMutation.isPending ? (
                                                    <>
                                                        <span className='spinner spinner-border spinner-border-sm mx-1'></span>
                                                        در حال دریافت
                                                    </>
                                                ) : (
                                                    <>
                                                        دریافت آدرس
                                                        <svg className={'me-1'} width="24" height="25" viewBox="0 0 24 25"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M9.25 12L10.75 13.5L14.75 9.5" stroke="#171717"
                                                                strokeWidth="2" strokeLinecap="round"
                                                                strokeLinejoin="round" />
                                                            <path
                                                                d="M5.97996 4.8C10.35 0.69 18.82 2.1 20.38 9.01C21.53 14.09 18.37 18.39 15.6 21.05C13.59 22.99 10.41 22.99 8.38996 21.05C5.62996 18.38 2.45996 14.08 3.61996 9"
                                                                stroke="#171717" strokeWidth="2" strokeLinecap="round"
                                                                strokeLinejoin="round" />
                                                        </svg>
                                                    </>
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                    <div className={'row align-items-center'}>
                                        <div className={'col-md-6 mb-2'}>
                                            <fieldset
                                                className={'mt-3'}>
                                                <label className={'form-label text-white mb-3'}>
                                                    استان
                                                </label>
                                                <input
                                                    type={'text'}
                                                    readOnly
                                                    className={address?.province ? 'form-control blue-bg' : 'form-control'}
                                                    {...register('province', { required: 'فیلد استان الزامی ست' })}
                                                />
                                            </fieldset>
                                        </div>
                                        <div className={'col-md-6 mb-2'}>
                                            <fieldset
                                                className={'mt-4'}>
                                                <label className={'form-label text-white mb-3'}>
                                                    شهر
                                                </label>
                                                <input
                                                    readOnly
                                                    type={'text'}
                                                    className={address?.province ? 'form-control blue-bg' : 'form-control'}
                                                    {...register('city', { required: 'فیلد شهر الزامی ست' })}
                                                />
                                            </fieldset>
                                        </div>
                                    </div>
                                    <div className={'row align-items-center'}>
                                        <div className={'col-12 mb-3'}>
                                            <fieldset
                                                className={'mt-3'}>
                                                <label className={'form-label text-white mb-3'}>
                                                    آدرس محل سکونت
                                                </label>
                                                <input
                                                    readOnly
                                                    type={'text'}
                                                    className={address?.province ? 'form-control blue-bg' : 'form-control'}
                                                    {...register('adress', { required: 'فیلد آدرس الزامی ست' })}
                                                />
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>
                                <div className={'col-md-6 order-md-1 order-0 mb-md-0 mb-4'}>
                                    <div className={'image-box card card-body border'}>
                                        <div className={'d-flex justify-content-between mt-2'}>
                                            <div className={'details mt-5'}>
                                                <p className={'font-medium'}>
                                                    <span className={'dark-green fw-bold'}>شماره ملی :</span>
                                                    {Cookies.get('nationalCode')}
                                                </p>
                                                <p className={'font-medium'}>
                                                    <span className={'dark-green fw-bold'}>نام و نام خانوادگی :</span>
                                                    {Cookies.get('name')}
                                                </p>
                                                <p className={'font-medium'}>
                                                    <span className={'dark-green fw-bold'}>تاریخ تولد :</span>
                                                    {Cookies.get('birthDay')}
                                                </p>
                                                <p className={'font-medium mb-0'}>
                                                    <span className={'dark-green fw-bold'}>نام پدر :</span>
                                                    {Cookies.get('fatherName')}
                                                </p>
                                            </div>
                                            <div className={'box-image'}>
                                                <img alt={'cart'} className={'img-fluid rounded rounded-4'}
                                                    src={`data:image/jpeg;base64,${localStorage.getItem('userImage')}`} />
                                                <div className='d-flex justify-content-center'>
                                                    <img style={{ width: '70px', height: '70px', objectFit: 'cover',marginTop:'-10px' }} src={require('./../../../assets/media/images/global/allah.png')} alt="" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={'d-flex justify-content-between mt-3'}>
                                <NavLink
                                    className={'btn form-btn back-btn rounded rounded-pill text-site px-4'}
                                    to={routes.auth[3].address}>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M15.85 8.99004C18.72 10.65 18.72 13.36 15.85 15.02L13.54 16.36L11.23 17.7C8.35 19.34 6 17.99 6 14.67V12V9.33004C6 6.02005 8.35 4.66005 11.22 6.32005"
                                            stroke="#31A59D" strokeWidth="2" strokeMiterlimit="10"
                                            strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    مرحله قبل
                                </NavLink>
                                <button type={'submit'}
                                    className={'btn form-btn fw-bold rounded rounded-pill p-2 px-4'}>
                                    ادامه
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            <ToastContainer />
        </>
    )
}

export default FoursStep;
